import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

const Landing = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary-600 to-secondary-600 text-white">
        <nav className="container mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            <Logo className="text-white" />
            <div className="space-x-4">
              <Link to="/login" className="hover:text-gray-200">Login</Link>
              <Link to="/register" className="bg-white text-primary-600 px-4 py-2 rounded-lg hover:bg-gray-100">
                Get Started
              </Link>
            </div>
          </div>
        </nav>

        <div className="container mx-auto px-6 py-20 text-center">
          <h2 className="text-5xl font-bold mb-6">
            Let Marketing Come Alive
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Transform simple product descriptions into high-quality, multi-channel marketing content
            with AI-powered creativity
          </p>
          <Link
            to="/register"
            className="inline-block bg-white text-primary-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition"
          >
            Start Creating for Free
          </Link>
        </div>
      </div>

      {/* Features Section */}
      <div className="container mx-auto px-6 py-20">
        <h3 className="text-3xl font-bold text-center mb-12">Why Choose Zest?</h3>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center p-6">
            <div className="text-4xl mb-4">⚡</div>
            <h4 className="text-xl font-semibold mb-2">Simple & Fast</h4>
            <p className="text-gray-600">
              One sentence input, multiple high-quality outputs in seconds
            </p>
          </div>
          <div className="text-center p-6">
            <div className="text-4xl mb-4">🎯</div>
            <h4 className="text-xl font-semibold mb-2">Multi-Channel Ready</h4>
            <p className="text-gray-600">
              Generate content for ads, social media, emails, and video scripts
            </p>
          </div>
          <div className="text-center p-6">
            <div className="text-4xl mb-4">🤖</div>
            <h4 className="text-xl font-semibold mb-2">AI-Powered</h4>
            <p className="text-gray-600">
              Powered by leading AI models trained for Western markets
            </p>
          </div>
        </div>
      </div>

      {/* Pricing Section */}
      <div className="bg-gray-50 py-20">
        <div className="container mx-auto px-6">
          <h3 className="text-3xl font-bold text-center mb-12">Simple, Transparent Pricing</h3>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {/* Free Plan */}
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h4 className="text-2xl font-bold mb-2">Free</h4>
              <div className="text-4xl font-bold mb-4">$0<span className="text-lg text-gray-600">/mo</span></div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  10 generations/month
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  All content types
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Basic support
                </li>
              </ul>
              <Link to="/register" className="block text-center bg-gray-200 text-gray-800 py-2 rounded-lg hover:bg-gray-300">
                Get Started
              </Link>
            </div>

            {/* Basic Plan */}
            <div className="bg-white p-8 rounded-lg shadow-md border-2 border-primary-600">
              <div className="text-xs text-primary-600 font-semibold mb-2">MOST POPULAR</div>
              <h4 className="text-2xl font-bold mb-2">Basic</h4>
              <div className="text-4xl font-bold mb-4">$29<span className="text-lg text-gray-600">/mo</span></div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  100 generations/month
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  All content types
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Priority support
                </li>
              </ul>
              <Link to="/register" className="block text-center bg-primary-600 text-white py-2 rounded-lg hover:bg-primary-700">
                Start Trial
              </Link>
            </div>

            {/* Professional Plan */}
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h4 className="text-2xl font-bold mb-2">Professional</h4>
              <div className="text-4xl font-bold mb-4">$99<span className="text-lg text-gray-600">/mo</span></div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  500 generations/month
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Advanced AI models
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Premium support
                </li>
              </ul>
              <Link to="/register" className="block text-center bg-gray-200 text-gray-800 py-2 rounded-lg hover:bg-gray-300">
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-6 text-center">
          <div className="flex justify-center mb-4">
            <Logo size="sm" className="text-white" />
          </div>
          <div className="mb-4">
            <Link to="/privacy" className="text-gray-300 hover:text-white mx-4">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-300 hover:text-white mx-4">
              Terms of Service
            </Link>
          </div>
          <p>&copy; 2025 Zest. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
